export { default } from 'components/activity/activity-panel';
export type { ActivityPanelProps as LeadActivityPanelProps } from 'components/activity/activity-panel';
